import { useContext } from 'react';

import OverlayContext from './Context';

export const useOverlay = () => useContext(OverlayContext);
